import { V } from '../Components.js';
import PointType from '../PointType.js';
import Spell from '../Spell.js';

import AreaOfEffects from '../../Actions/AreaOfEffects.js';
import Durations from '../../Actions/Durations.js';
import Effects from '../../Actions/Effects.js';
import Ranges from '../../Actions/Ranges.js';
import Times from '../../Actions/Times.js';
import ToHits from '../../Actions/ToHits.js';
import Utilities from '../../Actions/Utilities.js';

import AbilityType from '../../AbilityType.js';
import { DamageTypes } from '../../DamageType.js';
import Roll from '../../Roll.js';

export default new Spell(
  'Vicious Mockery',
  0,
  PointType.SpellSlot,
  [
    'You unleash a string of insults laced with subtle enchantments at a creature you can see within range. If the target can hear you (though it need not understand you), it must succeed on a Wisdom saving throw or take 1d4 psychic damage and have disadvantage on the next attack roll it makes before the end of its next turn.',
    "This spell's damage increases by 1d4 when you reach 5th level (2d4), 11th level (3d4), and 17th level (4d4).",
  ],
  Utilities.Combat,
  Times.Action,
  Durations.Instantaneous,
  Ranges.Range(60),
  AreaOfEffects.SingleTarget,
  ToHits.SpellSave(AbilityType.WIS),
  Effects.SpellDamageByCasterLevel(
    Roll.d(4),
    DamageTypes.Psychic,
    { 5: Roll.d(4), 11: Roll.d(4), 17: Roll.d(4) },
    true
  ),
  V,
  'Enchantment'
);
